<template>
    <div class="root">
        <v-subheader @dblclick="showAdvancedSettings = true">
            {{$vuetify.t('$vuetify.settings.title')}}
        </v-subheader>

        <v-btn color="success" block @click.prevent="showStats" class="mb-5" v-if="showAdvancedSettings">
            {{$vuetify.t('$vuetify.settings.showStatistics')}}
        </v-btn>

        <v-list-tile class="elevation-5 py-2 grey darken-3">
            <v-list-tile-action>
                <v-checkbox v-model="$store.state.settings.sound"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content @click="$store.commit('setSettingsSound', !$store.state.settings.sound)">
                <v-list-tile-title>
                    {{$vuetify.t('$vuetify.settings.sound')}}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                    {{$vuetify.t('$vuetify.settings.soundSub')}}
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

        <div class="elevation-5 py-2 grey darken-3 mt-2">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.camera')}}
            </v-subheader>

            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <v-select
                            :value="$store.state.settings.camera"
                            :items="cameras"
                            item-text="label"
                            item-value="deviceId"
                            @change="cameraChange($event)"
                        ></v-select>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>

        <div class="elevation-5 py-2 grey darken-3 mt-2" v-if="showAdvancedSettings">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.nfc_heading')}}
            </v-subheader>

            <v-list-tile>
                <v-list-tile-action>
                    <v-checkbox v-model="$store.state.settings.nfc"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click="$store.commit('setSettingsNfc', !$store.state.settings.nfc)">
                    <v-list-tile-title style="position: relative; top: -4px;">
                        {{$vuetify.t('$vuetify.settings.nfc')}}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>

        <div class="elevation-5 pt-2 grey darken-3 mt-2" v-if="showAdvancedSettings">
            <v-list-tile>
                <v-list-tile-action>
                    <v-checkbox v-model="$store.state.settings.showTicketCount"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click="$store.commit('setSettingsShowTicketCount', !$store.state.settings.showTicketCount)">
                    <v-list-tile-title style="position: relative; top: -4px;">
                        {{$vuetify.t('$vuetify.settings.showTicketCount')}}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>

        <div class="elevation-5 py-2 grey darken-3 mt-2">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.groupDisplay')}}
            </v-subheader>

            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <v-select
                                :value="$store.state.settings.group"
                                :items="groups"
                                item-text="label"
                                item-value="value"
                                @change="groupChange($event)"
                        ></v-select>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>

        <div class="elevation-5 py-2 grey darken-3 mt-2">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.olderEvents')}}
            </v-subheader>

            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <v-select
                                :value="$store.state.settings.olderEvents"
                                :items="olderEventsList"
                                item-text="label"
                                item-value="value"
                                @change="olderEventsChange($event)"
                        ></v-select>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>

        <div class="elevation-5 py-2 grey darken-3 mt-2">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.language')}}
            </v-subheader>

            <v-radio-group
                v-model="$vuetify.lang.current"
                @change="$store.commit('setSettingsLang', $vuetify.lang.current)"
                hide-details
            >
                <v-list-tile>   <!--  @click="" -->
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <v-radio
                                    key="cs"
                                    :label="$vuetify.t('$vuetify.settings.langCs')"
                                    value="cs"
                            ></v-radio>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <v-radio
                                    key="en"
                                    :label="$vuetify.t('$vuetify.settings.langEn')"
                                    value="en"
                            ></v-radio>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-radio-group>
        </div>

        <div class="elevation-5 py-2 grey darken-3 mt-2" v-if="showAdvancedSettings">
            <v-subheader class="loc-subheader">
                {{$vuetify.t('$vuetify.settings.qTitle')}}
            </v-subheader>

            <v-list-tile style="height: 24px; opacity: 0.5">
                <v-list-tile-content style="font-size: 14px">
                    <v-list-tile-title>
                        {{$vuetify.t('$vuetify.settings.qPatchSize')}}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <v-select
                                xlabel="$vuetify.t('$vuetify.settings.qPatchSize')"
                                v-model="patchSize"
                                :items="patchSizeItems"
                        ></v-select>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-list-tile style="height: 24px; opacity: 0.5">
                <v-list-tile-content style="font-size: 14px">
                    <v-list-tile-title>
                        {{$vuetify.t('$vuetify.settings.qFrequency')}}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <v-select
                                v-model="frequency"
                                :items="frequencyItems"
                        ></v-select>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </div>
        <br /><br />

        <h2>
            Seznam kódů ve frontě k odeslání
            (probíhá odesílání: <span v-if="$store.state.sendQueueSending">ANO</span><span v-else>NE</span>)
        </h2>
        <span v-for="row in $store.state.sendQueue">
            {{row.code}},
        </span>
        <div v-if="$store.state.sendQueue.length === 0">
            Fronta je prázdná
        </div>
    </div>
</template>

<script>

    export default {
        name: 'settings',

        data() {
            return {
                cameras: [],
                patchSize: this.$store.state.settings.patchSize,
                patchSizeItems: [20,30,40,50,60,70,80,90,100],

                frequency: this.$store.state.settings.frequency,
                frequencyItems: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],

                groups: [
                    { label: this.$vuetify.t('$vuetify.settings.groupDisplayNone'), value: ''},
                    { label: this.$vuetify.t('$vuetify.settings.groupDisplayEvent'), value: 'event'},
                    { label: this.$vuetify.t('$vuetify.settings.groupDisplayTicketset'), value: 'ticketset'},
                    { label: this.$vuetify.t('$vuetify.settings.groupDisplayPrice'), value: 'price'},
                    { label: this.$vuetify.t('$vuetify.settings.groupDisplayTicketsetPrice'), value: 'ticketset_price'},
                    // { label: this.$vuetify.t('$vuetify.settings.groupDisplayCategory'), value: 'category'}
                ],

                olderEventsList: [
                    { label: this.$vuetify.t('$vuetify.settings.olderEventsWeek'), value: 7},
                    { label: this.$vuetify.t('$vuetify.settings.olderEventsMonth'), value: 30},
                    { label: this.$vuetify.t('$vuetify.settings.olderEvents3Month'), value: 90},
                    { label: this.$vuetify.t('$vuetify.settings.olderEvents6Month'), value: 180},
                    { label: this.$vuetify.t('$vuetify.settings.olderEventsYear'), value: 365},
                    { label: this.$vuetify.t('$vuetify.settings.olderEventsAll'), value: 9999},
                ],

                showTicketCount: this.$store.state.settings.showTicketCount,

                showAdvancedSettings: false
            }
        },

        watch: {
            patchSize(val) {
                this.$store.commit('setSettingsPatchSize', val)
            },
            frequency(val) {
                this.$store.commit('setSettingsFrequency', val)
            }
        },

        created() {
            window.Html5Qrcode.getCameras().then(devices => {
                if (devices && devices.length) {
                    this.cameras = [
                        {
                            deviceId: '',
                            label: '-- Autodetect --'
                        },
                        {
                            deviceId: '-',
                            label: '-- Vypnout ctečku --'
                        },
                        ...devices.map(item => {
                            return {
                                deviceId: item.id,
                                label: item.label
                            }
                        })
                    ]
                }
            }).catch((/*err*/) => {
                // handle err
            })
        },

        methods: {
            cameraChange(deviceId) {
                this.$store.commit('setSettingsCamera', deviceId)
            },
            groupChange(value) {
                this.$store.commit('setSettingsGroup', value)
            },
            olderEventsChange(value) {
                this.$store.commit('setSettingsOlderEvents', value)
            },
            showStats() {
                this.$router.push({name:'statistics'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-text-field {
        padding-top: 0;
        margin-top: 0;
    }

    .v-input--radio-group {
        margin-top: 0;
        padding-top: 0;
    }

    .loc-subheader {
        height: 32px;
    }
</style>
